<template>
  <div class="page-intro">
    <banner />
    <div class="g-wrap">
      <div class="g-tabs">
        <a
          :class="{ active: item.id == activeTab }"
          v-for="item in tabList"
          :key="item.id"
          @click="handleTab(item)"
          >{{ item.text }}</a
        >
      </div>
    </div>
    <keep-alive>
      <component :is="activeComp"></component>
    </keep-alive>
  </div>
</template>

<script>
import PanelBase from "./components/Base";
import PanelJob from "./components/Job";
import PanelTalent from "./components/Talent";
import Banner from "./components/Banner";
export default {
  data() {
    return {
      tabList: [
        {
          id: "base",
          comp: PanelBase.name,
          text: "基本信息"
        },
        {
          id: "job",
          comp: PanelJob.name,
          text: "岗位信息"
        },
        {
          id: "talent",
          comp: PanelTalent.name,
          text: "人才培养"
        }
      ],
      activeTab: "base",
      activeComp: PanelBase.name
    };
  },
  components: {
    [PanelBase.name]: PanelBase,
    [PanelJob.name]: PanelJob,
    [PanelTalent.name]: PanelTalent,
    [Banner.name]: Banner
  },
  methods: {
    handleTab(item) {
      this.activeTab = item.id;
      this.activeComp = item.comp;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-intro {
}
</style>
